(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["archive-viewer-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (root.dataset.archiveViewerCarouselWired === 'true') return;
      root.dataset.archiveViewerCarouselWired = 'true';

      var track = root.querySelector('[data-archive-viewer-carousel-track]');
      var dotsWrap = root.querySelector('[data-archive-viewer-dots]');
      var footer = root.querySelector('[data-archive-viewer-footer]');
      var total = parseInt(root.getAttribute('data-total'), 10) || 0;
      var counts = (root.getAttribute('data-counts') || '')
        .split(',')
        .filter(function (s) { return s !== ''; })
        .map(function (s) { return parseInt(s, 10) || 0; });
      if (!track || total < 1) return;

      var currentIndex = 0;

      var DRAG_MAX = 150;
      var DRAG_EASE = 45;
      var DRAG_FIRE = 30;

      // Which product a flat slide index belongs to, and its position inside
      // that product's own photos.
      function locate(flat) {
        var start = 0;
        for (var p = 0; p < counts.length; p++) {
          if (flat < start + counts[p]) return { p: p, i: flat - start, count: counts[p] };
          start += counts[p];
        }
        return { p: 0, i: 0, count: counts[0] || 0 };
      }

      function renderDots() {
        var loc = locate(currentIndex);
        if (footer) footer.style.display = loc.count > 1 ? '' : 'none';
        if (!dotsWrap) return;
        var visibleDots = Math.min(loc.count, 5);
        if (dotsWrap.children.length !== visibleDots) {
          dotsWrap.innerHTML = '';
          for (var d = 0; d < visibleDots; d++) {
            var span = document.createElement('span');
            span.className = 'archive-viewer-carousel__dot';
            dotsWrap.appendChild(span);
          }
        }
        var dots = Array.prototype.slice.call(dotsWrap.children);
        if (loc.count <= visibleDots) {
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === loc.i);
            dot.classList.remove('is-edge-small');
          });
          return;
        }
        var windowStart = loc.i - Math.floor(visibleDots / 2);
        windowStart = Math.max(0, Math.min(windowStart, loc.count - visibleDots));
        var activeSlot = loc.i - windowStart;
        dots.forEach(function (dot, slot) {
          dot.classList.toggle('is-active', slot === activeSlot);
          var isEdge =
            (slot === 0 && windowStart > 0) ||
            (slot === visibleDots - 1 && windowStart + visibleDots - 1 < loc.count - 1);
          dot.classList.toggle('is-edge-small', isEdge);
        });
      }

      function setTrackTransform(px, animate) {
        track.style.transition = animate ? 'transform 0.25s ease' : 'none';
        track.style.transform = 'translateX(' + px + 'px)';
      }

      function getCurrentTranslateX() {
        var value = getComputedStyle(track).transform;
        if (!value || value === 'none') return 0;
        var match = value.match(/matrix\(([^)]+)\)/);
        if (!match) return 0;
        var parts = match[1].split(',');
        return parseFloat(parts[4]) || 0;
      }

      function goToIndex(index, animate) {
        currentIndex = Math.max(0, Math.min(total - 1, index));
        setTrackTransform(-currentIndex * track.clientWidth, animate !== false);
        renderDots();
      }

      function announce() {
        root.dispatchEvent(
          new CustomEvent('archive-viewer:carousel-change', {
            bubbles: true,
            detail: { index: currentIndex }
          })
        );
      }

      var dragging = false;
      var startX = 0;
      var startY = 0;
      var baseX = 0;
      var wasDrag = false;

      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      function startDrag(x) {
        wasDrag = false;
        baseX = getCurrentTranslateX();
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + baseX + 'px)';
        startX = x;
      }

      function nudgeTo(dx) {
        if (Math.abs(dx) > 8) wasDrag = true;
        var nudge = (dx < 0 ? -1 : 1) * DRAG_MAX * Math.tanh(Math.abs(dx) / DRAG_EASE);
        track.style.transform = 'translateX(' + (baseX + nudge) + 'px)';
      }

      function commitDrag(dx) {
        if (total < 2) {
          goToIndex(currentIndex);
          return;
        }
        if (dx <= -DRAG_FIRE) {
          if (currentIndex + 1 >= total) goToIndex(0, false);
          else goToIndex(currentIndex + 1);
          announce();
        } else if (dx >= DRAG_FIRE) {
          if (currentIndex - 1 < 0) goToIndex(total - 1, false);
          else goToIndex(currentIndex - 1);
          announce();
        } else {
          goToIndex(currentIndex);
        }
      }

      var EDGE_GUARD_PX = 50;
      var touchDirectionDecided = false;
      var touchIsHorizontal = false;

      track.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length > 1) return;
          var touch = e.touches[0];
          dragging = false;
          touchDirectionDecided = false;
          touchIsHorizontal = false;
          startY = touch.clientY;
          startDrag(touch.clientX);
          if (touch.clientX < EDGE_GUARD_PX) {
            e.preventDefault();
          }
        },
        { passive: false }
      );

      track.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length > 1) {
            if (dragging) {
              dragging = false;
              goToIndex(currentIndex);
            }
            return;
          }
          var touch = e.touches[0];
          if (!touch) return;
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;

          if (!touchDirectionDecided) {
            touchDirectionDecided = true;
            touchIsHorizontal = Math.abs(dx) >= Math.abs(dy);
            dragging = touchIsHorizontal;
          }
          if (!touchIsHorizontal) return;

          e.preventDefault();
          nudgeTo(dx);
        },
        { passive: false }
      );

      function endTouchDrag(e) {
        if (!dragging) return;
        dragging = false;
        var touch = e.changedTouches[0];
        var dx = touch ? touch.clientX - startX : 0;
        commitDrag(dx);
      }
      track.addEventListener('touchend', endTouchDrag);
      track.addEventListener('touchcancel', endTouchDrag);

      var mouseDragging = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        mouseDragging = true;
        startDrag(e.clientX);
        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      track.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch' || !mouseDragging) return;
        nudgeTo(e.clientX - startX);
      });

      function endMouseDrag(e) {
        if (e.pointerType === 'touch' || !mouseDragging) return;
        mouseDragging = false;
        try {
          track.releasePointerCapture(e.pointerId);
        } catch (err) {}
        commitDrag(e.clientX - startX);
      }
      track.addEventListener('pointerup', endMouseDrag);
      track.addEventListener('pointercancel', endMouseDrag);

      track.addEventListener(
        'click',
        function (e) {
          if (wasDrag) {
            e.stopPropagation();
            e.preventDefault();
            wasDrag = false;
          }
        },
        true
      );

      window.addEventListener('resize', function () {
        goToIndex(currentIndex, false);
      });

      root.archiveViewerCarousel = {
        goTo: function (index, animate) {
          goToIndex(index, animate);
        }
      };

      goToIndex(0, false);
    }

    function initAll() {
      document.querySelectorAll('[data-archive-viewer-carousel]').forEach(initCarousel);
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    if (document.readyState !== 'loading') initAll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swipe-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (root.dataset.swipeCarouselWired === 'true') return;
      root.dataset.swipeCarouselWired = 'true';

      var track = root.querySelector('[data-swipe-carousel-track]');
      var dotsWrap = root.querySelector('[data-swipe-carousel-dots]');
      var total = parseInt(root.getAttribute('data-total'), 10) || 0;
      if (!track || total < 2) return;

      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.swipe-carousel__dot')) : [];
      var visibleDots = dots.length;
      var currentIndex = 0;

      /* Same drag-feel constants as the daystep-arrow drag in
         blocks/sudoku-carousel-grid.liquid — a small tanh-eased nudge while
         dragging, capped well short of a full slide, then a full-width
         commit or spring-back animation on release. */
      var DRAG_MAX = 150; // px the track can visually nudge at most while dragging (the ceiling)
      var DRAG_EASE = 45; // RESISTANCE: finger px to reach ~3/4 of the ceiling
      var DRAG_FIRE = 30; // raw finger px in a direction that counts as "go" on release

      function renderDots() {
        if (!dots.length) return;
        var activeIndex = currentIndex;

        if (total <= visibleDots) {
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === activeIndex);
            dot.classList.remove('is-edge-small');
          });
          return;
        }

        var windowStart = activeIndex - Math.floor(visibleDots / 2);
        windowStart = Math.max(0, Math.min(windowStart, total - visibleDots));
        var activeSlot = activeIndex - windowStart;

        dots.forEach(function (dot, slot) {
          dot.classList.toggle('is-active', slot === activeSlot);
          var isEdge =
            (slot === 0 && windowStart > 0) ||
            (slot === visibleDots - 1 && windowStart + visibleDots - 1 < total - 1);
          dot.classList.toggle('is-edge-small', isEdge);
        });
      }

      function setTrackTransform(px, animate) {
        track.style.transition = animate ? 'transform 0.25s ease' : 'none';
        track.style.transform = 'translateX(' + px + 'px)';
      }

      // Reads where the track ACTUALLY is right now, instead of assuming it
      // has already finished its 0.25s settle animation from the last
      // commit. Without this, starting a new drag mid-animation snaps the
      // image to the wrong spot before your finger has even moved.
      function getCurrentTranslateX() {
        var value = getComputedStyle(track).transform;
        if (!value || value === 'none') return 0;
        var match = value.match(/matrix\(([^)]+)\)/);
        if (!match) return 0;
        var parts = match[1].split(',');
        return parseFloat(parts[4]) || 0;
      }

      function goToIndex(index, animate) {
        currentIndex = Math.max(0, Math.min(total - 1, index));
        setTrackTransform(-currentIndex * track.clientWidth, animate !== false);
        renderDots();
      }

      var dragging = false;
      var startX = 0;
      var startY = 0;
      var baseX = 0;
      var wasDrag = false;

      // Belt-and-suspenders alongside the img's draggable="false" attribute:
      // native browser image drag (Chrome/Firefox's built-in "drag to save/
      // move this image") hijacks the gesture before pointermove ever fires,
      // which looks exactly like "dragging does nothing."
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      function startDrag(x) {
        wasDrag = false;
        baseX = getCurrentTranslateX();
        track.style.transition = 'none';
        // Cancelling the transition above snaps to whatever value was
        // already SPECIFIED (the full commit target), not the interpolated
        // value just read — so that value has to be explicitly re-applied
        // as the new starting point, or the image still jumps to the end
        // of its last slide-in the instant you touch it again.
        track.style.transform = 'translateX(' + baseX + 'px)';
        startX = x;
      }

      function nudgeTo(dx) {
        if (Math.abs(dx) > 8) wasDrag = true;
        var nudge = (dx < 0 ? -1 : 1) * DRAG_MAX * Math.tanh(Math.abs(dx) / DRAG_EASE);
        track.style.transform = 'translateX(' + (baseX + nudge) + 'px)';
      }

      function commitDrag(dx) {
        if (dx <= -DRAG_FIRE) {
          goToIndex(currentIndex + 1);
        } else if (dx >= DRAG_FIRE) {
          goToIndex(currentIndex - 1);
        } else {
          goToIndex(currentIndex);
        }
      }

      // ---- Touch drag (phones/tablets) ----
      //
      // Rebuilt 2026-09-25 to match Owl Carousel's actual architecture — the
      // library the site's old theme used, which never had this problem on
      // real iPhones. The previous version drove the drag with the Pointer
      // Events API (pointerdown/pointermove/setPointerCapture) while a
      // SEPARATE plain Touch Events listener tried to defeat iOS's edge-
      // swipe-back gesture. Two parallel event systems tracking the same
      // finger is exactly what Owl's code never does — it drives everything
      // from one system (raw touch/mouse events) with no pointer capture at
      // all. On-device testing (2026-09-25) showed the OS gesture itself was
      // successfully defeated (events came through with cancelable=true) yet
      // the drag still silently failed to commit on the backward swipe only
      // — consistent with the two systems disagreeing, not with the OS
      // fighting us. This version removes Pointer Events from the touch path
      // entirely; touch is driven start-to-finish by touchstart/touchmove/
      // touchend/touchcancel, the same events used to fight the OS gesture,
      // so there's only one source of truth for a given finger.
      //
      // Direction is decided once, on the first touchmove, exactly like Owl
      // Carousel's onDragStart: if the first move reads more vertical than
      // horizontal, this touch is released to the page (native scroll/
      // dismiss) and never becomes a drag. Otherwise preventDefault() fires
      // on every touchmove for the rest of the gesture, unconditionally —
      // not re-checked move-by-move — which is what actually keeps Safari's
      // edge-back gesture from reclaiming the touch midway through a long
      // drag.
      var EDGE_GUARD_PX = 50;
      var touchDirectionDecided = false;
      var touchIsHorizontal = false;

      track.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length > 1) return;
          var touch = e.touches[0];
          dragging = false;
          touchDirectionDecided = false;
          touchIsHorizontal = false;
          startY = touch.clientY;
          startDrag(touch.clientX);
          if (touch.clientX < EDGE_GUARD_PX) {
            e.preventDefault();
          }
        },
        { passive: false }
      );

      track.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length > 1) {
            // A second finger joining mid-drag means this is a pinch, not a
            // swipe — abort cleanly and let the browser handle the pinch.
            if (dragging) {
              dragging = false;
              goToIndex(currentIndex);
            }
            return;
          }
          var touch = e.touches[0];
          if (!touch) return;
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;

          if (!touchDirectionDecided) {
            touchDirectionDecided = true;
            touchIsHorizontal = Math.abs(dx) >= Math.abs(dy);
            dragging = touchIsHorizontal;
          }
          if (!touchIsHorizontal) return;

          e.preventDefault();
          nudgeTo(dx);
        },
        { passive: false }
      );

      function endTouchDrag(e) {
        if (!dragging) return;
        dragging = false;
        var touch = e.changedTouches[0];
        var dx = touch ? touch.clientX - startX : 0;
        commitDrag(dx);
      }
      track.addEventListener('touchend', endTouchDrag);
      track.addEventListener('touchcancel', endTouchDrag);

      // ---- Mouse drag (desktop) ----
      //
      // Pointer Events, restricted to non-touch pointer types only — desktop
      // has none of the iOS gesture conflicts above, so the simpler API is
      // fine here and was never the problem.
      var mouseDragging = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        mouseDragging = true;
        startDrag(e.clientX);
        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      track.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch' || !mouseDragging) return;
        nudgeTo(e.clientX - startX);
      });

      function endMouseDrag(e) {
        if (e.pointerType === 'touch' || !mouseDragging) return;
        mouseDragging = false;
        try {
          track.releasePointerCapture(e.pointerId);
        } catch (err) {}
        commitDrag(e.clientX - startX);
      }
      track.addEventListener('pointerup', endMouseDrag);
      track.addEventListener('pointercancel', endMouseDrag);

      // Swallow the trailing click a drag gesture leaves behind, so a swipe
      // that starts/ends over the padded (non-image) part of a slide never
      // gets mistaken for the "click outside the image closes the lightbox"
      // gesture elsewhere in the page.
      track.addEventListener(
        'click',
        function (e) {
          if (wasDrag) {
            e.stopPropagation();
            e.preventDefault();
            wasDrag = false;
          }
        },
        true
      );

      window.addEventListener('resize', function () {
        goToIndex(currentIndex, false);
      });

      // The carousel only sets up once per page load, so without this,
      // reopening a lightbox after swiping through it once would silently
      // resume wherever it was left instead of starting at image 1 again.
      // Whatever opens the carousel (e.g. the lightbox trigger) should call
      // this each time it opens.
      root.resetSwipeCarousel = function () {
        goToIndex(0, false);
      };

      goToIndex(0, false);
    }

    function initAll() {
      document.querySelectorAll('[data-swipe-carousel]').forEach(initCarousel);
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
